<template>
  <div id="app">
    <component :is="view" :view.sync="view"></component>
  </div>
</template>

<script>
import Home from './components/Home.vue';
import Game from './components/Game.vue';
import Card from './components/Card.vue';

export default {
  name: 'App',
  components: {
    Home,
    Game,
    Card,
  },
  data() {
    return {
      view: 'Home',
    };
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
}

#app {
  font-family: 'Noto Sans TC', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
